import React from "react";
import "../Posts/PostsStyle/AnswersList.css";

import AnswerItem from "./AnswerItem";

function AnswersList({ answers, questionId }) {
  return (
    <div className="post__answer">
      {answers.map(({ answer, answerId, questionId: qId, timestamp, user }) => (
        <AnswerItem
          answer={answer}
          answerId={answerId}
          answerQuestionId={qId}
          questionId={questionId}
          timestamp={timestamp}
          user={user}
        />
      ))}
    </div>
  );
}

export default AnswersList;
